<template>
	<div :class="{ 'banner-wrap': true }">
		<van-swipe
			@change="slideChange"
			:duration="500"
			ref="swipe"
			indicator-color="white"
		>
			<van-swipe-item v-if="videoKey">
        <vue-aliplayer-v2 
			:source="videoKey" 
			ref="slideVideo" 
			:options="options"
			:cssLink="`https://g.alicdn.com/de/prismplayer/2.9.22/skins/default/aliplayer-min.css`"
			:scriptSrc="`https://fr-static.shopshops.top/20220712/aliplayer2922.3705b20da73cf62f.js`"
		  />
				<!-- <video-wrap videoEl="#goods_banner_video">
					<Player
						:playUrl="videoKey"
						ref="slideVideo"
						@playCb="activePlay"
						:isLive="false"
						:isInitPlay="isInitPlay"
					/>
				</video-wrap> -->
			</van-swipe-item>
			<van-swipe-item v-for="(item, index) in bannerData" :key="index">
				<img
					class="banner-pic"
					v-lazy="
						handleImg({ url: item.resourceKey.url, width: 750, height: 750 })
					"
					@click="viewImg(index)"
					alt=""
				/>
			</van-swipe-item>
		</van-swipe>
	</div>
</template>
<script>
const playerOpt = {
  isLive: false,
  autoplay: true,
  width: '100%',
  height: '100%',
  playsinline: true,
  x5_fullscreen: false,
  preload: true,
  x5_type: 'h5',
  x5_video_position: 'top',
  rePlay: true,
  useH5Prism: true,
  showBarTime: '3000',
  controlBarVisibility: 'click',
  skinLayout: [
    {name: "bigPlayButton", align: "cc"},
    {name: "H5Loading", align: "cc"},
	{
	name: "controlBar", 
	align: "blabs", x: 0, y: 0,
	children: [
		{name: "progress", align: "blabs", x: 0, y: 44},
		{name: "playButton", align: "tl", x: 15, y: 12},
		{name: "timeDisplay", align: "tl", x: 10, y: 7},
		// {name: "fullScreenButton", align: "tr", x: 10, y: 12},
		// {name:"subtitle", align:"tr",x:15, y:12},
		// {name:"setting", align:"tr",x:15, y:12},
		// {name: "volume", align: "tr", x: 5, y: 10}
	]
	}
  ]
}
import { Swipe, SwipeItem, ImagePreview } from "vant";
export const GoodsBannerType = 2;
export default {
	components: {
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
		[ImagePreview.name]: ImagePreview,
	},
	data() {
		return {
			slideIndex: 0,
			initialIndex: 0,
			isPlay: false,
			isInitPlay: false,
      options: playerOpt
		};
	},
	props: {
		videoKey: String,
		data: Array,
		h5: Boolean,
	},
	computed: {
		bannerData() {
			let array = (this.data || [])
				.filter((item) => item.resourceBizType === GoodsBannerType)
				.sort((a, b) => a.sort - b.sort);

			return array.length > 5 ? array.slice(0, 5) : array;
		},
	},
	mounted() {
		document.addEventListener("visibilitychange", () => {
			if (document.visibilityState === "hidden") {
				this.$refs.slideVideo && this.$refs.slideVideo.player.pause();
			}
			// 用户打开或回到页面
			if (document.visibilityState === "visible") {
				if (this.$refs.slideVideo) {
					if (!this.slideIndex) {
						this.$refs.slideVideo.player.play();
					}
				}
			}
		});
	},
	methods: {
		slideChange(index) {
			// 轮播图改变事件
			// index 当前轮播图索引
			this.slideIndex = index;
			if (this.videoKey) {
				// 视频
				if (index) {
					// 暂停
					this.$refs.slideVideo.player.pause();
				} else {
					// 播放
					this.$refs.slideVideo.player.play();
				}
			}
		},
		slideNavClick(type) {
			// 视频 图片 按钮点击
			if (type === "video" && this.slideIndex) {
				// 视频
				this.$refs.slideVideo.player.play();
				this.$refs.swipe.swipeTo(0);
			}
			if (type === "picture" && !this.slideIndex) {
				// 按钮
				this.$refs.swipe.swipeTo(1);
				this.$refs.slideVideo.player.pause();
			}
		},
		// 预览轮播
		viewImg(index) {
			this.initialIndex = index;
			ImagePreview({
				images: this.bannerData.map((item) => (item.resourceKey || {}).url),
				closeable: true,
				loop: false,
				startPosition: index,
			});
		},
		activePlay(val) {
			// 避免重复播放
			if (val && !this.isPlay) {
				this.isPlay = true;
			}
		},
	},
	watch: {
		videoKey: {
			immediate: true,
			handler(val) {
				if (val) {
					this.isInitPlay = true;
				}
			},
		},
	},
};
</script>
<style lang="less" scoped>
.van-swipe {
	height: 100%;
}
img {
	display: block;
}
.banner-wrap {
	position: relative;
	width: 100vw;
	max-width: 375px;
	height: 100vw;
	max-height: 375px;
	.nav {
		position: absolute;
		left: 50%;
		bottom: 28px;
		display: flex;
		transform: translate(-50%, -50%);
		z-index: 11;
		span {
			width: 44px;
			height: 22px;
			font-size: 12px;
			line-height: 22px;
			text-align: center;
			border-radius: 3px;
			color: #161a1a;
			background: rgba(244, 247, 247, 0.5);
			transition: all 0.3s ease;
			&:first-child {
				margin-right: 11px;
			}
		}
		.active {
			color: #fff;
			background: #57818b;
		}
	}
	.banner-pic {
		width: 100vw;
		height: 100vw;
		max-width: 375px;
		max-height: 375px;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	video {
		display: block;
		width: 100%;
		height: 100%;
	}
	.my-dot {
		position: relative;
		bottom: 15px;
		width: 12px;
		height: 4px;
		background-color: #fff;
		border-radius: 2px;
		&.active {
			width: 16px;
			background-color: #519d9e;
		}
	}
}
#J_Player {
	width: 100% !important;
	height: 100% !important;
}
#J_Player video {
	width: auto !important;
	object-fit: contain !important;
	height: 100% !important;
}
</style>

<style lang="less">
.banner-wrap{
	.prism-player .prism-controlbar{
		z-index: 20 !important;
	}
	.prism-player .prism-liveshift-progress .prism-progress-played, .prism-player .prism-progress .prism-progress-played{
		background-color: rgba(255,255,255, .7) !important;
	}
//   .prism-player {
//     .prism-controlbar{
//       width: 95%;
//     }
//     .prism-liveshift-progress,  .prism-progress {
//       width: 65%;
// 	  .prism-progress-marker{
// 	    width: 100%;
// 	  }
//     }
//     .prism-time-display{
//       width: 87%;
//     }
//   }
}
</style>
